import React from "react";
import { FaCheckCircle } from "react-icons/fa";

import { category } from "../tool";


const EditType = ({ form, setForm, setData }) => {

    const saveType = (type) => {
        setForm((data) => ({
            ...data,
            "category": type
        }))
        setData((dataItem) => ({
            ...dataItem,
            "category": type
        }))
    };

    // console.log(form.category)

    return (
        <div className="edit-warp-content-type">
            <ul>{category.map((item, index) => (
                <li key={index}>
                    <div onClick={() => saveType(item.eng)}
                        className={form.category === item.eng 
                                                    ? 'active' : null}>
                        {form.category === item.eng 
                                        ?  <FaCheckCircle size={24} className="check"/> : null}
                        {item.icon}
                        <p>{item.name}</p>
                    </div>
                </li>
            ))}</ul>
        </div>
    )
};


export default EditType;